// Form-field states (design manual Ch08 §3.1, "form-field states"): the border
// says whether the field is plain, focused, wrong or accepted. One helper, so
// no input chooses its own reds.
import { cn } from '@/lib/utils';

export type FieldState = 'normal' | 'error' | 'success';

const BASE =
  'rounded-md border bg-card px-3 py-1.5 text-sm text-tres-text-primary placeholder:text-tres-text-secondary ' +
  'focus:outline-none focus:ring-1 disabled:bg-muted disabled:text-tres-text-secondary';

const STATE: Record<FieldState, string> = {
  normal: 'border-input focus:border-tres-action focus:ring-tres-action',
  error: 'border-tres-error focus:border-tres-error focus:ring-tres-error',
  success: 'border-tres-success focus:border-tres-success focus:ring-tres-success',
};

/** Class names for an <input>, <select> or <textarea> in the given state. */
export function fieldClass(state: FieldState = 'normal', className?: string): string {
  return cn(BASE, STATE[state], className);
}
